import React from "react";
import NewItineraryContent from "../components/trips/new-itinerary-content";

const NewItinerary = () => {
  return <NewItineraryContent />;
};

export default NewItinerary;
